<!-- AI: This is the template for the new CompanyFormFieldsComponent. -->
<div *ngIf="!editMode">
  <app-text label="Company Form">{{ getCompanyFormDescription() }}</app-text>
</div>
<ng-container *ngIf="editMode" [formGroup]="formGroup">
  <mat-form-field *ngIf="formGroup.get('country').value === 'FI'">
    <mat-select placeholder="Company Form" formControlName="company_form_code">
      <mat-option *ngFor="let form of companyForms" [value]="form.code">
        {{form.description_fi}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field *ngIf="formGroup.get('country').value !== 'FI'">
    <input matInput placeholder="Company Form" formControlName="company_form_other" />
  </mat-form-field>
</ng-container>
